import { getAccessToken } from 'src/routes/AuthContext';
import { patientApiPaths } from '../constants';
import { baseApiUrl } from 'src/config';

type Discipline = 'PT' | 'OT' | 'SLP';

export const getEpisodeOfCareDownloads = async (
  realm: string,
  episodeOfCareId: string,
  discipline: Discipline,
  uuids: string[]
): Promise<string | null> => {
  const token = await getAccessToken();

  const url = `${baseApiUrl}${patientApiPaths.createPatient}${patientApiPaths.episodeOfCare}/download-files-by-selection/${episodeOfCareId}/${discipline}`;

  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'x-tenant-id': realm,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(uuids),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      return data.data.s3UploadPath || null;
    })
    .catch((error) => {
      throw Error(`Error fetching download URLs: ${error}`);
    });
};
